import { FINANCE_CONFIG } from './config.js';
import { addDaysUTC, createUTCDate, daysInUTCMonth, parseDateUTC, toDateKeyUTC } from './dates.js';
import { getEntityId, getTransactionLabel } from './entities.js';
import { findOverride, occursOnDate } from './recurrence.js';
export function getDailyNet(transaction, date) {
    if (transaction.type === 'transfer') {
        return 0;
    }
    const amount = findOverride(transaction, date)?.amount ?? transaction.amount;
    return transaction.type === 'income' ? amount : -amount;
}
export function toProjectionMovement(transaction, date) {
    const override = findOverride(transaction, date);
    return {
        amount: override?.amount ?? transaction.amount,
        date: toDateKeyUTC(date),
        label: getTransactionLabel(transaction),
        net: getDailyNet(transaction, date),
        toWalletId: getEntityId(transaction.toWallet),
        transactionId: transaction.id ?? null,
        type: transaction.type,
        walletId: getEntityId(override?.wallet ?? transaction.wallet),
    };
}
export function getMonthlyProjectionSeries(transactions, year, month, options = {}) {
    const totalDays = daysInUTCMonth(year, month);
    const points = [];
    let balance = options.startingBalance ?? 0;
    for (let day = 1; day <= totalDays; day += 1) {
        const date = createUTCDate(year, month, day);
        const movements = transactions
            .filter((transaction) => occursOnDate(transaction, date, options))
            .filter((transaction) => options.includeTransfers === true || transaction.type !== 'transfer')
            .map((transaction) => toProjectionMovement(transaction, date));
        const net = movements.reduce((sum, movement) => sum + movement.net, 0);
        balance += net;
        points.push({ balance, date: toDateKeyUTC(date), movements, net });
    }
    return points;
}
export function getCurrentWalletBalance(wallets) {
    return wallets.reduce((total, wallet) => total + (wallet.balance ?? wallet.currentBalance ?? wallet.availableBalance ?? 0), 0);
}
export function getNextMovement(transactions, fromDate, options = {}) {
    const start = parseDateUTC(fromDate);
    const end = createUTCDate(FINANCE_CONFIG.projection.maxYear, 12, 31);
    for (let date = start; date <= end; date = addDaysUTC(date, 1)) {
        for (const transaction of transactions) {
            if (occursOnDate(transaction, date, options)) {
                const movement = toProjectionMovement(transaction, date);
                if (movement.amount !== 0) {
                    return movement;
                }
            }
        }
    }
    return null;
}
export function summarizeMonth(transactions, year, month, options = {}) {
    const series = getMonthlyProjectionSeries(transactions, year, month, options);
    let income = 0;
    let expenses = 0;
    for (const point of series) {
        for (const movement of point.movements) {
            if (movement.net > 0)
                income += movement.net;
            if (movement.net < 0)
                expenses += Math.abs(movement.net);
        }
    }
    const recurring = transactions.filter((transaction) => transaction.active !== false &&
        transaction.type !== 'transfer' &&
        transaction.frequency !== 'one-time').length;
    return { balance: income - expenses, expenses, income, recurring };
}
//# sourceMappingURL=ledger.js.map